import React from "react";
import ReversalVsManagement from "../components/ReversalVsManagement/ReversalVsManagement";
const ReversalVsManage = props => {
  return <ReversalVsManagement />;
};

export default ReversalVsManage;
